import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useAuthHandling } from '../useAuthhandling';
import Cookies from 'js-cookie';
import Suspendednormal from './Suspendednormal';
import Suspendedprofessional from './Suspendedprofessional';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import { IoArrowBack } from 'react-icons/io5';

function Suspeneduserlist() {
    let navigate = useNavigate();
    const { isAuthorized, handleUnauthorized } = useAuthHandling();

    const tokens = Cookies.get("a_token");
    if (!tokens) {
        navigate("/");
    }
    const [usertype, setUsertype] = useState('professional');

  return (
    <div className="container-scroller">
    <Navbar />

    <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
            <div className="content-wrapper">
               
                    <div className='row'>
                    <div className='user_all_list-head_new'>
  <Link to="/userlist" className='list_back_btn'  >
<IoArrowBack />
</Link>
                        <div className='user_view_head'>
                            
                            <div className={usertype === 'professional' ? 'user_view_head_list active' : "user_view_head_list"} onClick={(e) => setUsertype('professional')}>
                                Professional User
                            </div>
                            <div className={usertype === 'normal' ? 'user_view_head_list active' : "user_view_head_list"} onClick={(e) => setUsertype('normal')}>
                                Normal User
                            </div>
                        </div>
                    </div>
                    </div>
                 

                    {usertype==='professional'?
                    <Suspendedprofessional />
                    :    usertype==='normal'?
                    <Suspendednormal />
                    :""
                }
            </div>
        </div>
    </div>

</div>
  )
}

export default Suspeneduserlist
